module.exports = __webpack_public_path__ + "static/img/cont213.a618f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont213.jpg
// module id = cU5l
// module chunks = 0